import { isBackendAPIError } from '@atlassian/jira-fetch/src/utils/is-error.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';

const projectTemplatesEndpoint = '/rest/simplified/2.0/project-templates';

type ProjectTypeTemplate = {
	canCreate?: boolean | null;
};

type ProjectTemplate = {
	projectTypeTemplates?: {
		companyManaged?: ProjectTypeTemplate | null;
	} | null;
};

type ProjectTemplatesResponse = {
	templates?: ProjectTemplate[] | null;
};

type SolutionComposerAnalyticsAttributes = {
	inProductExperience: string;
};

export const solutionComposerAnalyticsAttributes: SolutionComposerAnalyticsAttributes = {
	inProductExperience: 'jsmComposer',
};

export const getHasCMPCreatePermissionFromProjectTemplates = async (): Promise<boolean> => {
	const response = await performGetRequest<ProjectTemplatesResponse>(projectTemplatesEndpoint);
	return (
		response.templates?.some(
			(template) => template.projectTypeTemplates?.companyManaged?.canCreate === true,
		) ?? false
	);
};

export const fireCMPCreatePermissionCheckErrorAnalytics = (e: unknown): void => {
	fireErrorAnalytics({
		meta: {
			id: 'rovoAiProjectSpotlightModalPermissionCheck',
			packageName: 'servicedeskSolutionComposer',
			teamName: 'jsm-nebula',
		},
		error: e instanceof Error ? e : new Error(String(e)),
		attributes: {
			skipSentry: isBackendAPIError(e),
			...solutionComposerAnalyticsAttributes,
		},
	});
};
